import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './breadcrumb-progress.css'

import TickIcon from '../../../assets/icons/tick.svg'

const BreadcrumbProgressItem = ({ label, active, complete }) => {
  const itemClass = classNames({
    'item-complete': complete,
    'item-active': active && !complete,
    'item-disabled': !active && !complete,
  })

  return (
    <li styleName={itemClass}>
      <span styleName={complete ? 'icon-visible' : 'icon-hidden'}><TickIcon /></span>
      <span styleName="label">{label}</span>
    </li>
  )
}

BreadcrumbProgressItem.propTypes = {
  active: PropTypes.bool,
  complete: PropTypes.bool,
  label: PropTypes.string,
}

export default CSSModules(BreadcrumbProgressItem, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/breadcrumb-progress/breadcrumb-progress-item.js
 **/